import { render, staticRenderFns } from "./dbguanggt_config.vue?vue&type=template&id=65473d64&scoped=true&"
import script from "./dbguanggt_config.vue?vue&type=script&lang=js&"
export * from "./dbguanggt_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65473d64",
  null
  
)

export default component.exports